(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets"] && !Shopify.designMode) return;
  try {
    (() => {
    const theme = (window.theme = window.theme || {});

    const sectionFetch = async (root, url) => {
      const target = new URL(url, window.location.origin);
      target.searchParams.set('section_id', root.dataset.sectionId);
      const response = await fetch(target);
      if (!response.ok) throw new Error(response.statusText);
      return new DOMParser().parseFromString(await response.text(), 'text/html');
    };

    const swap = (root, doc, selector) => {
      const fresh = doc.querySelector(selector);
      root.querySelectorAll(selector).forEach((current) => {
        if (fresh) current.innerHTML = fresh.innerHTML;
      });
    };

    const update = async (root, url, push = true) => {
      root.classList.add('is-loading');
      const focused = document.activeElement;
      const focusKey = focused?.name ? `[name="${CSS.escape(focused.name)}"][value="${CSS.escape(focused.value)}"]` : null;

      try {
        const doc = await sectionFetch(root, url);
        ['[data-facets-results]', '[data-facets-body]', '[data-facets-results-count]', '.facets__footer'].forEach((selector) =>
          swap(root, doc, selector)
        );

        const count = doc.querySelector('[data-facets-count]');
        root.querySelectorAll('[data-facets-count]').forEach((badge) => {
          badge.textContent = count?.textContent || '0';
          badge.hidden = !count || count.hidden;
        });

        if (push) window.history.pushState({ facets: true }, '', url);
        if (focusKey) root.querySelector(focusKey)?.focus();
        theme.reveal?.(root);
        document.dispatchEvent(new Event('wishlist:sync'));
      } catch {
        window.location.href = url;
      } finally {
        root.classList.remove('is-loading');
      }
    };

    const formUrl = (form) => {
      const params = new URLSearchParams();
      new FormData(form).forEach((value, key) => {
        if (value !== '') params.append(key, value);
      });
      return `${window.location.pathname}?${params}`;
    };

    document.addEventListener('change', (event) => {
      const form = event.target.closest('[data-facets]');
      const root = form?.closest('[data-facets-root]');
      if (!form) return;
      if (!root) return form.requestSubmit();
      update(root, formUrl(form));
    });

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-facets]');
      const root = form?.closest('[data-facets-root]');
      if (!form || !root) return;
      event.preventDefault();
      update(root, formUrl(form));
    });

    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[data-facets-link], [data-facets-results] .pagination a');
      const root = link?.closest('[data-facets-root]');
      if (!link || !root) return;
      event.preventDefault();
      update(root, link.href);
      if (link.closest('.pagination')) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    window.addEventListener('popstate', () => {
      const root = document.querySelector('[data-facets-root]');
      if (root) update(root, window.location.href, false);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (() => {
    const KEY = 'oferti:wishlist';

    const read = () => {
      try {
        return JSON.parse(localStorage.getItem(KEY)) || [];
      } catch {
        return [];
      }
    };

    const sync = () => {
      const list = read();
      document.querySelectorAll('[data-wishlist]').forEach((button) => {
        button.setAttribute('aria-pressed', list.includes(button.dataset.wishlist));
      });
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-wishlist]');
      if (!button) return;

      const list = read();
      const index = list.indexOf(button.dataset.wishlist);
      if (index === -1) list.unshift(button.dataset.wishlist);
      else list.splice(index, 1);

      try {
        localStorage.setItem(KEY, JSON.stringify(list));
      } catch {}

      sync();
      if (index === -1) {
        button.classList.remove('is-popping');
        void button.offsetWidth;
        button.classList.add('is-popping');
      }
      document.dispatchEvent(new CustomEvent('wishlist:change', { detail: list }));
    });

    // Other components dispatch this after injecting new cards into the page.
    document.addEventListener('wishlist:sync', sync);
    window.addEventListener('pageshow', sync);
    sync();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-input"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const step = event.target.closest('[data-quantity-step]');
    if (!step) return;

    const input = step.parentElement.querySelector('input');
    if (Number(step.dataset.quantityStep) > 0) input.stepUp();
    else input.stepDown();
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["theme-behaviors"] && !Shopify.designMode) return;
  try {
    (() => {
    const theme = (window.theme = window.theme || {});
    document.documentElement.classList.add('theme-ready');
    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const reducedMotion = {
      get matches() {
        return motionQuery.matches || document.documentElement.classList.contains('no-animations');
      },
    };
    theme.reducedMotion = reducedMotion;

    const observer =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                entry.target.classList.add('is-revealed');
                observer.unobserve(entry.target);
              });
            },
            { rootMargin: '0px 0px -6% 0px', threshold: 0.08 }
          )
        : null;

    theme.reveal = (root = document) => {
      root.querySelectorAll('[data-reveal]:not(.is-revealed)').forEach((element) => {
        if (!observer || reducedMotion.matches) element.classList.add('is-revealed');
        else observer.observe(element);
      });
    };

    theme.openDialog = (id) => {
      const dialog = document.getElementById(id);
      if (!dialog || dialog.open) return dialog;
      dialog.classList.remove('is-closing');
      dialog.showModal();
      dialog.dispatchEvent(new CustomEvent('dialog:open'));
      return dialog;
    };

    theme.closeDialog = (dialog) => {
      if (!dialog?.open || dialog.classList.contains('is-closing')) return;
      if (reducedMotion.matches) return dialog.close();
      dialog.classList.add('is-closing');

      // Child animations bubble too, so only react to the dialog's own; the timer is a safety net.
      let done = false;
      const finish = () => {
        if (done) return;
        done = true;
        dialog.removeEventListener('animationend', onEnd);
        dialog.classList.remove('is-closing');
        dialog.close();
      };
      const onEnd = (event) => {
        if (event.target === dialog) finish();
      };
      dialog.addEventListener('animationend', onEnd);
      setTimeout(finish, 450);
    };

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-dialog-open]');
      if (opener && document.getElementById(opener.getAttribute('aria-controls'))) {
        event.preventDefault();
        theme.openDialog(opener.getAttribute('aria-controls'));
        return;
      }

      const closer = event.target.closest('[data-dialog-close]');
      if (closer) theme.closeDialog(closer.closest('dialog'));

      // A click on the backdrop targets the dialog element itself.
      if (event.target instanceof HTMLDialogElement) theme.closeDialog(event.target);
    });

    // Escape: play the exit animation instead of closing instantly.
    document.addEventListener(
      'cancel',
      (event) => {
        if (!(event.target instanceof HTMLDialogElement)) return;
        event.preventDefault();
        theme.closeDialog(event.target);
      },
      true
    );

    theme.reveal();
    document.addEventListener('shopify:section:load', (event) => theme.reveal(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
